var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 47,
    viewBox: "0 0 58 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9166 0.125C36.4916 0.125 31.7124 2.8375 28.9999 7.1C26.2874 2.8375 21.5083 0.125 16.0833 0.125C7.55825 0.125 0.583252 7.1 0.583252 15.625C0.583252 30.9958 28.9999 46.625 28.9999 46.625C28.9999 46.625 57.4166 31.125 57.4166 15.625C57.4166 7.1 50.4416 0.125 41.9166 0.125Z",
    fill: "#4F3085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.70b451feb329f2012c0016b844e705d5.svg";
export { ForwardRef as ReactComponent };